import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  AntSwitch,
  Colors, FindLoad,
  Images,
  PermissionsList,
  RolePermission,
  useGlobalStyles,
  useGlobalText,
  useModal, usePrimaryModal,
  userType,
} from 'utils';
import { Circle, CsvFile, FullTable, Line, MinLoader, ToastScreen } from 'components';
import { CreateLoadBtn } from '../../createLoad/core';
import { groupLoadsBody, groupLoadsHead, ACTION_TYPE } from './constants';
import { loadActions, LoadServices, templateActions } from 'store';
import { loadCsv } from '../../../../pages/loads/fragments/constants';
import { buttonsStyle } from '../../../../components/buttons/styles';
import { ExportInvoice } from './exportInvoice';
import { LoadDetailSwitcher } from '../../../../pages';
import { toast } from 'react-toastify';

export const GroupLoads = ({ afterSuccess }) => {
  const { groupLoads, groupById } = useSelector((state) => ({
    groupLoads: state.loads.groupLoads,
    groupById: state.loads.groupById,
  }));
  const classes = buttonsStyle();
  const globalStyles = useGlobalStyles();
  const globalText = useGlobalText();
  const dispatch = useDispatch();
  const history = useHistory();
  // const info = history?.location?.state;
  const params = useParams();
  // const params = useParams();
  const { open } = useModal();
  const { openPrimary } = usePrimaryModal();
  const loadGroupBilling = FindLoad('loadGroupBilling')
  const [selectedId, setSelectedId] = useState(null);
  const [readyForBilling, setReadyForBilling] = useState(groupById?.readyForBilling || false);

  useEffect(() => {
    if (groupById?.id){
      dispatch(loadActions.getGroupPayableLoads(groupById?.id));
      dispatch(loadActions.getGroupLoads(groupById?.id));
    }
  }, [groupById?.id]);

  const pushPageDetails = (id) => {
    openPrimary(<LoadDetailSwitcher loadId={id} />)

    // history.push({
    //   pathname: `/grouped-load/${id}/group/${groupById?.id}`,
    //   state: { loadParams: { ...info } },
    // });
  };

  const changeGroupBilling = async (e, item) => {
    setSelectedId(item?.id);
    try {
      await LoadServices.ChangeGroupBilling(item?.id, !item?.bill?.groupBilling);
      dispatch(loadActions.getGroupLoads(groupById?.id, 'noLoad'));
      if(afterSuccess){
        afterSuccess();
      }
      toast(
        <ToastScreen
          type={'success'}
          text={'Invoice was successfully sent to the email!'}
        />,
      );
      setSelectedId(null);
    } catch (e) {
      setSelectedId(null);
    }
  };

  const handlePauseBilling = () => {
    setReadyForBilling(!readyForBilling);
    dispatch(loadActions.pauseGroupLoadBilling(groupById?.id, !readyForBilling))
  }


  return (
    <div>
      <div className="space-between">
        <div className={globalStyles.centerItem}>
          <Circle number={3} back={Colors.ThemeAqua} />
          <p className={globalText.title}>Loads</p>
        </div>
        <div className="align-center" style={{ gap: 12 }}>

          <div className="flex-align-center" style={{gap: 12}}>
            <span className="setting-title">{'Ready For Billing'}</span>
            <AntSwitch
              onClick={handlePauseBilling}
              checked={readyForBilling}
            />
          </div>

          <button
            className={classes.csvExportBtn}
            onClick={() => open(<ExportInvoice />)}
          >
            <img src={Images.download} alt="icon" />
            <p className={globalText.downloadText}>
              Generate Invoice
            </p>
          </button>
          {groupById?.status !== 'CANCELLED' && userType !== 'ADMIN' &&
            <CreateLoadBtn groupId={groupById?.id} />
          }
        </div>
      </div>

      <div className={globalStyles.flexAndFullWidth}>
        <div className={'MuiAccordionDetails-root'}>
          <Line height={'auto'} />
        </div>
        <div className="full-width" style={{ marginBottom: 24 }}>
          <FullTable
            height={'medium'}
            head={groupLoadsHead}
            body={groupLoadsBody(changeGroupBilling, selectedId)}
            loadingType={ACTION_TYPE}
            list={groupLoads || []}
            noText={'Loads'}
            handleClick={pushPageDetails}
          />
        </div>
      </div>
    </div>
  );
};